import React from 'react'

import styles from './AdminPanel.module.scss'

const AdminPanel = () => <div className={styles.adminPanel}>Administrator mode</div>

export default AdminPanel
